/* eslint-disable no-console */
/** @module 工具模块-公共库日志类 */
const captureStackInfo = require('./helpers/stack');

const reviseType = (params) => Object.prototype.toString.call(params).slice(8, -1); // 返回变量的类型

function microTime([sec, nano]) {
  return Math.round(sec * 1e6 + nano / 1e3);
}

const LevelEnum = {
  log: 'log',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error',
};

const LevelNumEnum = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
};

/**
 * 通用日志类
 */
class Logger {
  static mInstance;

  static getInstance() {
    if (!Logger.mInstance) {
      Logger.mInstance = new Logger();
      Logger.mInstance.setConf({});
    }
    return Logger.mInstance;
  }

  /**
   * @description 设置配置，目前主要设置输出的日志级别
   * @param config
   * @return {void}
   */
  setConf(config) {
    this.logLevel = config.logLevel || 'info';
  }

  /**
   * 判断当前打印的日志级别，是否大于限制打印的日志级别，大于限制则打印
   * @param printLevel
   * @return {boolean}
   */
  checkLogLevel(printLevel) {
    const limitLevelNum = LevelNumEnum[this.logLevel];
    const printLevelNum = LevelNumEnum[printLevel];
    return printLevelNum >= limitLevelNum;
  }

  /**
   * @description log级别日志输出 (当前仅作为debug的别名)
   * @param {string} msg 日志消息字符串
   * @param {array} meta
   * @return {void}
   */
  log(msg, meta) {
    this.print(LevelEnum.debug, msg, meta);
  }

  /**
   * @description debug级别日志输出
   * @param {string} msg 日志消息字符串
   * @param {array} meta
   * @return {void}
   */
  debug(msg, meta) {
    this.print(LevelEnum.debug, msg, meta);
  }

  /**
   * @description info级别日志输出
   * @param {string} msg 日志消息字符串
   * @param {array} meta
   * @return {void}
   */
  info(msg, meta) {
    this.print(LevelEnum.info, msg, meta);
  }

  /**
   * warn级别日志输出
   * @param {string} msg 日志消息字符串
   * @param {array} meta
   * @return {void}
   */
  warn(msg, meta) {
    this.print(LevelEnum.warn, msg, meta);
  }

  /**
   * error级别日志输出
   * @param {string} msg 日志消息字符串
   * @param {array} meta
   * @return {void}
   */
  error(msg, meta) {
    this.print(LevelEnum.error, msg, meta);
  }

  /**
   * 将 inputData 和 logData 合并，注意保留字，不能覆盖保留字，如果重名，将 inputData的key 加后缀 _in
   * @param {object} logData 日志对象
   * @param {object} inputData 输入的对象数据
   * @return {object}
   */
  mergeData(logData, inputData) {
    const newData = {};
    // proventKeys 保留字，不允许从外部传入，不能被覆盖
    const proventKeys = Object.keys(logData);
    Object.keys(inputData).forEach((key) => {
      if (proventKeys.includes(key)) {
        // evnet 允许从外部传入
        if (['event'].includes(key)) {
          newData[key] = inputData[key];
        } else {
          newData[`${key}_in`] = inputData[key];
        }
      } else {
        newData[key] = inputData[key];
      }
    });

    return Object.assign(logData, newData);
  }

  /**
   * log 和 info是一个实现，warn和error不支持颜色，浏览器自动高亮颜色,
   * debug对应verbose(Chrome支持)
   * @param {string} level 日志输出级别 (log 和 info是一个实现，warn和error不支持颜色，浏览器自动高亮颜色, debug对应verbose(Chrome支持))
   * @param {string} msg 日志消息字符串
   * @param {array} meta 参数
   * @return {void}
   */
  print(level, msg, meta) {
    try {
      const innerLevel = level.toUpperCase();
      const nowTime = Date.now();
      let reqId = 'nil';
      let reqStartTime = 0;

      // check log level
      const checkFlag = this.checkLogLevel(level);
      if (!checkFlag) {
        return;
      }

      // 参数类型
      const msgType = reviseType(msg);
      const argsType = reviseType(meta);

      // request id
      let reqIp = 0;
      let reqUin = 0;

      if (process.domain) {
        const { id, startTime, cip, uin } = process.domain;
        reqId = id;
        reqIp = cip;
        reqUin = uin;
        reqStartTime = startTime;
      }

      // 日志保留字, 初始化
      let logData = {
        L: innerLevel,
        timestamp: nowTime,
        requestId: reqId,
        event: 'raw-log',
        reqLife: reqStartTime,
        M: '',
        C: '',
        reqIp,
        reqUin,
      };
      logData.requestId = reqId;

      if (reqId && reqStartTime) {
        logData.reqLife = microTime(process.hrtime(reqStartTime));
      }

      // stack line
      const stackStore = {};
      Error.captureStackTrace(stackStore);
      const { line } = captureStackInfo(stackStore);
      logData.C = line;

      if (msgType === 'String') {
        logData.M = msg; // 如果传入的msg为字符，会被当作M的参数进行收集

        if (argsType === 'Object') {
          // 对应的是 logger.info('', {})
          logData = this.mergeData(logData, meta);
        }
      }

      // 第一个参数就是 object, 将忽略后面的参数
      if (msgType === 'Object') {
        logData = this.mergeData(logData, msg);
      }
      console.log(JSON.stringify(logData));
    } catch (error) {}
  }
}

module.exports = Logger.getInstance();
